import axios from "axios";

// 创建独立的 axios 实例用于统计接口
const statRequest = axios.create({
  timeout: 60000,
});

// 如果需要可以在这里添加独立的拦截器
statRequest.interceptors.request.use(
  (config) => {
    // 这里可以添加统计接口需要的特殊 header
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

statRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default statRequest;
